import { action, decorate, observable, reaction } from 'mobx';
import agent from '../api/agent';
import { IRequestReviewDocumentQuestion } from '../models/RequestReviewDocumentQuestions';
import { RootStore } from './RootStore';

export default class RequestReviewDocumentQuestionStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
    }

    DocumentQuestions: IRequestReviewDocumentQuestion[] | null = null;
    DocumentQuestionsHash: string | null = null;

    GetDocumentsFromLocalStorage = async () => {
        const localDocumentQuestions = localStorage.getItem('DocumentQuestions');
        const DocumentQuestionsHash = localStorage.getItem('DocumentQuestionsHash');

        if (localDocumentQuestions !== null && DocumentQuestionsHash != null) {
            this.DocumentQuestions = JSON.parse(localDocumentQuestions);
            this.DocumentQuestionsHash = JSON.parse(DocumentQuestionsHash);
        }
        else {
            await this.LoadDocuments();
        }
    }

    LoadDocuments = async () => {
        const RequestReviewDocumentQuestions = await agent.RequestReviewDocumentQuestions.list();

        localStorage.setItem('DocumentQuestions', JSON.stringify(RequestReviewDocumentQuestions.requestReviewDocumentQuestionsDTO));
        localStorage.setItem('DocumentQuestionsHash', RequestReviewDocumentQuestions.requestReviewDocumentQuestionsHash);

        this.DocumentQuestions = RequestReviewDocumentQuestions.requestReviewDocumentQuestionsDTO;
        this.DocumentQuestionsHash = RequestReviewDocumentQuestions.requestReviewDocumentQuestionsHash;

    }

    CheckHash = async () => {
        const RequestReviewDocumentQuestionsHash = await agent.RequestReviewDocumentQuestions.hash();

        if (this.DocumentQuestionsHash !== RequestReviewDocumentQuestionsHash) {
            await this.LoadDocuments();
        }
    }

    GetFilteredDocumentTypes = () => {
        //return documentTypes if QuestionCount !=0
        const documentQuestions = this.DocumentQuestions!;

        var Questions: {
            DocumentType: string;
            Question: string;
            Limit: number;
            Order: number;
        }[] = [];

        var Documents: {
            key: string;
            text: string;
            value: string;
        }[] = [];

        if (documentQuestions !== null) {
            documentQuestions.map(
                (Doc: any, index) => {
                    const requirements = JSON.parse(Doc.requirements);

                    var Ors: { Flag: string; Group: number; }[][] = [];

                    var groupNum = 1;
                    while (groupNum <= requirements.Requirement.length) {

                        const reqs = requirements.Requirement.values(
                            (g: { Flag: string; Group: number; }) => g.Group === groupNum
                        )

                        var reqs2: { Flag: string; Group: number; }[] = [];
                        // Here all the elements of the array is being printed. 
                        for (let elements of reqs) {
                            if (elements.Group === groupNum) {
                                reqs2.push(elements)
                            }
                        }

                        if (reqs2.length !== 0) {
                            Ors.push(reqs2);
                        }
                        groupNum++;
                    }
                    let PrevAnd: boolean = true;
                    let PrevOr: boolean = false;

                    Ors.map((ands, index) => {
                        ands.map((and, index) => {
                            PrevAnd = PrevAnd && this.Requirements(and.Flag);
                        })
                        PrevOr = PrevOr || PrevAnd;
                        PrevAnd = true;
                    })
                    if (PrevOr) {
                        Questions.push({
                            "DocumentType": Doc.documentType,
                            "Question": Doc.question,
                            "Limit": Doc.documentTypeLimit,
                            "Order": Doc.documentTypeOrder
                        })
                    }
                }
            );

            //sort document types
            Questions = Questions.sort(x => x.Order);

            var docs = []
            for (var x in Questions) {
                try {
                    if (Questions[x].Limit === 0 || this.rootStore.requestReviewDocumentStore.getDocumentTypeCountInArray(Questions[x].DocumentType) < Questions[x].Limit) {
                        docs.push(Questions[x].DocumentType)
                    }
                }
                catch (error) {
                    console.log(error)
                }
            };

            //get unquie document types
            var filteredDocs = docs.filter((value, index, self) => {
                return self.indexOf(value) === index;
            }
            )

            //push up document types
            filteredDocs.map(
                (value, index,) => {

                    Documents.push({ "key": value, "text": value, "value": value });
                }
            )
        }
        return Documents;
    }

    Requirements = (requirement: string) => {
        if (requirement === "Always") { return true; }
        if (requirement === "IsPortRequest") { if (this.rootStore?.requestReviewStore?.RequestReview?.portRequest) { return true; } else { return false; } }
        if (requirement === "IsDA15589User") { if (this.rootStore?.requestReviewStore?.RequestReview?.dA15589User) { return true; } else { return false; } }
        if (requirement === "IsNotDA15589User") { if (!this.rootStore?.requestReviewStore?.RequestReview?.dA15589User) { return true; } else { return false; } }
        if (requirement === "DataElementCode0") { if (this.rootStore?.requestReviewStore?.RequestReview?.dataElementCode === '0') { return true; } else { return false; } }
        if (requirement === "DataElementCode1") { if (this.rootStore?.requestReviewStore?.RequestReview?.dataElementCode === '1') { return true; } else { return false; } }
        if (requirement === "DataElementCode2") { if (this.rootStore?.requestReviewStore?.RequestReview?.dataElementCode === '2') { return true; } else { return false; } }
        if (requirement === "DataElementCode3") { if (this.rootStore?.requestReviewStore?.RequestReview?.dataElementCode === '3') { return true; } else { return false; } }
        if (requirement === "DataElementCode4") { if (this.rootStore?.requestReviewStore?.RequestReview?.dataElementCode === '4') { return true; } else { return false; } }
        return false;
    }

}

decorate(RequestReviewDocumentQuestionStore, {
    DocumentQuestions: observable,
    DocumentQuestionsHash: observable,
    GetDocumentsFromLocalStorage: action,
    LoadDocuments: action,
    CheckHash: action,
    GetFilteredDocumentTypes: action,
});